import styled from '@emotion/styled';

export const SideMenuStyled = styled.div`
    width: max(358px, 25%);
    z-index: 11;

    padding: 0.8rem;
    .sideMenu {
        background-color: #41578f;
        color: white;
        height: 100%;
        border-radius: 10px;
        padding: 1.3rem 1.8rem;
    }

    @media (max-width: 900px) {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: min(92vw, 380px);
        padding: 0.7rem;

        .sideMenu {
            height: 100%;
            overflow-y: auto;
        }
    }
`;
